import React from "react";
import styles from "./stylesComponent/Card.module.css";
import {Link} from 'react-router-dom';



const CardUser = ({ tutor }) => {

    return(
        <Link to={{ pathname: `/detalleTutor/${tutor._id}`, state: { tutor: tutor } }}>
            <div className={styles.card}>
                <img src={`data:image/png;base64,${tutor.ImagenPerfil}`} alt={`${tutor.Nombre} ${tutor.Apellidos}`} style={{ alignSelf: 'center', height: '60%', width: '60%',  border: '1px solid black', borderRadius: '50%', background: 'white' }}  />
                <div className={styles.data}>
                    <p>{tutor.Nombre} {tutor.Apellidos}</p>
                    <div className={styles.tematicas} title={tutor.Tematicas?.join(", ")}>
                        <span>{tutor.Tematicas?.join(", ")}</span>
                    </div>
                </div>
            </div>
        </Link>
    );
};

export default CardUser;